import React from 'react';
import { Link } from 'react-router-dom';
import { CircleCheck, ArrowRight, MapPinned, ShieldCheck, BadgeDollarSign } from 'lucide-react';
import { IMAGES } from '../../data/site';
import { Reveal } from '../common/Reveal';

const badges = [
  { icon: MapPinned, title: 'Locally Owned & Operated', text: 'Proudly serving New Jersey communities with local expertise and commitment.' },
  { icon: ShieldCheck, title: 'Licensed & Insured', text: 'Fully licensed and insured for your peace of mind and protection.' },
  { icon: BadgeDollarSign, title: 'Competitive Pricing', text: 'Offering top-quality services at affordable, competitive rates.' },
];

export const TrustBadges = () => (
  <section className="pb-12 pt-2 bg-background" data-testid="trust-badges-section">
    <div className="max-w-[1320px] mx-auto px-4 lg:px-8 grid grid-cols-1 md:grid-cols-3 gap-6">
      {badges.map((b, i) => (
        <Reveal key={b.title} delay={i * 0.08}>
          <div className="h-full rounded-2xl bg-dark text-dark-foreground p-7 flex flex-col card-lift" data-testid={`trust-badge-${b.title.toLowerCase().replace(/[^a-z]+/g, '-')}`}>
            <b.icon className="w-7 h-7 text-[hsl(var(--primary-glow))]" />
            <h3 className="font-heading font-bold text-lg mt-4">{b.title}</h3>
            <p className="mt-2 text-dark-foreground/70 text-[15px]">{b.text}</p>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);

const trustList = [
  'Roof repairs and replacements',
  'Chimney inspections and repairs',
  'Gutter installation and maintenance',
  'Emergency roofing services',
];

export const CompanyTrust = () => (
  <section className="py-24 bg-secondary" data-testid="company-trust-section">
    <div className="max-w-[1320px] mx-auto px-4 lg:px-8 grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
      <Reveal className="order-2 lg:order-1">
        <img src={IMAGES.trustHouse} alt="A company that you can trust" className="w-full h-[360px] md:h-[440px] object-cover rounded-3xl" loading="lazy" />
      </Reveal>
      <Reveal delay={0.1} className="order-1 lg:order-2">
        <span className="eyebrow">Local Roofing Company At Your Service</span>
        <h2 className="section-title mt-4" data-testid="company-trust-title">A Company That You Can Trust</h2>
        <p className="mt-5 text-lg text-muted-foreground">
          Dependable, honest, and committed to delivering exceptional roofing services. We handle all types of roofing services.
        </p>
        <ul className="mt-6 space-y-3.5">
          {trustList.map((t) => (
            <li key={t} className="flex items-start gap-3 font-heading font-semibold">
              <CircleCheck className="w-5 h-5 text-primary mt-1 shrink-0" />
              {t}
            </li>
          ))}
        </ul>
        <Link to="/free-estimate" className="btn-cta mt-9" data-testid="company-trust-cta">
          Get in Touch <ArrowRight className="w-4 h-4" />
        </Link>
      </Reveal>
    </div>
  </section>
);
